

export const getRouteLabel = (_route) => {

    let _ret = "";
    switch(_route){
        case "home.menu": _ret = "Bookmanager"; break; 
        case "inventory.inventory": _ret = "Inventory"; break; 
        case "inventory.history": _ret = "History"; break; 
        case "orders.orders": _ret = "Orders"; break; 
        case "suppliers.suppliers": _ret = "Suppliers"; break; 
        case "pos.pos": _ret = "Point of Sale"; break; 
        case "customer.customer": _ret = "Customers"; break; 
        case "processing.processing": _ret = "Order Processing"; break; 
        case "reports.reports": _ret = "Reports"; break; 
        case "reports.custom_inventory": _ret = "Reports ▸ Custom Inventory"; break; 
        case "reconciliation.reconciliation": _ret = "Reconciliation"; break; 
    }

    return _ret; 

}

export const ROUTES = {


    // DUEL KEYS
    GLOBAL: {
        GLOBAL: "global.global",
        DOCS : "global.docs",
        CLASSFILE: "global.classfile",
        INVENTORY: "global.inventory",
        MAINTENANCE: "global.maintenance",
        EMPLOYEE_LOGIN: "global.employee_login",
        REQUEST_CLERK_CODE: "global.request_clerk_code",
        SETUP: "global.setup",
        SETUP_PASSWORDS: "global.setup_passwords",
        SETUP_PASSWORDS_RIGHT: "global.setup_passwords_right",
        SETUP_TAXCODES: "global.setup_taxcodes",
        SETUP_TAXCODES_RIGHT: "global.setup_taxcodes_right",
        SETUP_TAXCODES_NEW: "global.setup_taxcodes_new",
        SETUP_TAXCODES_SEARCH: "global.setup_taxcodes_search",
        SETUP_TAXCODES_NEW: "global.setup_taxcodes_new",
        SETUP_TAXTYPES_NEW_TYPE: "global.setup_taxcodes_new_type",
        SETUP_POS : "global.setup_pos",
        PRINTER_SETTINGS : "global.printer_settings"
    },

    AUTHENTICATION: {
        LOGIN: "authentication.login",
        LOGOUT: "authentication.logout",
        STORES: "authentication.stores",
    },
    EMPLOYEE: {
        EDIT: "employee.edit"
    },
    HOME: {
        MENU: "home.menu",
        STATIONS: "home.stations",
        TOOLS: "home.tools"
    },
    POS: {
        POS: "pos.pos",
        EDIT: "pos.edit",
        ITEMS: "pos.items",
        SEARCH : "pos.search",
        SEARCH_RESULTS : "pos.search_results",
        CUSTOMER: "pos.customer",
        CUSTOMER_EXTRAS: "pos.customer_extras",
        SEARCH_ISBN : "pos.search_isbn",
        TENDER : "pos.tender",
        PRINT : "pos.print",
        PRINT_EDIT : "pos.print_edit",
        PRINT_OPTIONS : "pos.print_options",
        FINAL : "pos.final",
        CHANGE_DISCOUNTS : "pos.change_discounts",
        CHANGE_QUANTITIES : "pos.change_quantities",
        CHANGE_FB : "pos.change_fb",
        CHANGE_PURCHASE_ORDERS : "pos.change_purchase_orders",
        GIFT_CARD : "pos.gift_card",
        NEW_GIFT_CARD : "pos.new_gift_card",
        NEW_GIFT_CARD_BATCH : "pos.new_gift_card_batch",
        GIFT_CARD_ACTIVITY : "pos.gift_card_activity"
    },
    GL: {
        GL: "gl.gl",
        ACCOUNTS: "gl.accounts"
    },
    REPORTS: {
        REPORTS: "reports.reports",
        CUSTOM_INVENTORY: "reports.custom_inventory",
        CUSTOM_INVENTORY_GROUPS: "reports.custom_inventory_groups",
        CUSTOM_EDIT: "reports.custom_edit",
        COLUMNS: "reports.columns",
        FILTER: "reports.filter",
        FILTER_SELECT: "reports.filter_select",
        FILTER_EDIT: "reports.filter_edit",
        FILTER_SALES_IN: "reports.filter_sales_in",
        FILTER_INVOICES_BETWEEN: "reports.filter_invoices_between",
        FILTER_INVENTORY_BETWEEN: "reports.filter_inventory_between",
        IMPORT_REPORTS: "reports.import_reports",
        SEARCH : "reports.search",
        PRINT_EXPORT : "reports.print_export",

        INVENTORY_REPORT_VIEWER : "reports.inventory_report_viewer"
    },
    CUSTOMER: {
        CUSTOMER: "customer.customer",
        MESSAGES: "customer.messages",
        ALERTS: "customer.alerts",
        EDIT: "customer.edit",
        FILTERS: "customer.filters",
        FILTERS_EDIT: "customer.filters_edit",
        BILL_TO: "customer.bill_to",
        CUSTOM_CUSTOMER_GROUPS: "customer.custom_customer_groups",
        FILTER: "customer.filter",
        FILTER_SELECT: "customer.filter_select",
        FILTER_EDIT: "customer.filter_edit",
        HISTORY: "customer.history",
        EXTRA: "customer.extra",
        PRINT: "customer.print",
        DETAILS: "customer.details",
        SEARCH: "customer.search",
        AR: "customer.ar",
        AR_TOTAL: "customer.ar_total",
        PRINT_ORDER_ACTIVITY: "customer.print_order_activity",
        PRINT_SALES_PERIOD: "customer.print_sales_period",
        PRINT_INVOICE_HISTORY: "customer.print_invoice_history",
        ADDRESS : "customer.address",
        ADDRESS_EDIT : "customer.address_edit"
    },
    ORDERS: {
        ORDERS: "orders.orders",
        EDIT : "orders.edit",
        SEARCH : "orders.search",
        FILTER : "orders.filter",
        SECTION_CODE : "orders.section_code",
        EXTRA : "orders.extra",
        EXTRA_DISCOUNT: "orders.extra_discount",
        GL_ACCOUNT: "orders.gl_account",

    },
    PROCESSING: {
        PROCESSING: "processing.processing",
        ORDER_TOTALS_BY_SECTION: "processing.ordertotalsbysection",
        UPDATE: "processing.update"
    },
    INVENTORY: {
        INVENTORY: 'inventory.inventory',
        EDIT: "inventory.edit",
        SEARCH: "inventory.search",
        SORT: "inventory.sort",
        RESERVE: "inventory.reserve",
        RESERVE_FORM: "inventory.reserve_form",
        EXTRA: "inventory.extra",
        MESSAGE: "inventory.message",
        AUTHORPICKER: "inventory.authorpicker",
        AUTHORPICKER_TITLE: "inventory.authorpicker_title",
        HISTORY: "inventory.history",
        ADJUST: "inventory.adjust",
        PUBSTOCK: "inventory.pubstock",
        ORDERS: "inventory.orders",
        ORDERS_EDIT : "inventory.orders_edit",
        ORDER: "inventory.order",
        LABELS : "inventory.labels",
    },
    SUPPLIERS: {
        SUPPLIERS: "suppliers.suppliers"
    },
    RECONCILIATION: {
        RECONCILIATION: "reconciliation.reconciliation",
        ADJUST: "reconciliation.adjust",
        COUNT: "reconciliation.count",
        NEW: "reconciliation.new",
        SEARCH: "reconciliation.search",
        EXTRA: "reconciliation.extra",
        SOUNDS: "reconciliation.sounds",
        EXPORT_COUNTS: "reconciliation.export_counts",
        RESET_INVENTORY: "reconciliation.reset_inventory",
        FIND_INVENTORY: "reconciliation.find_inventory",
        PURGE_LIST: "reconciliation.purge_list",
        ZERO_COUNTS: "reconciliation.zero_counts",
        IMPORT: "reconciliation.import",
        VIEW_FILE: "reconciliation.view_file",
        VIEW_FILE_SEARCH: "reconciliation.view_file_search",
        FIND_ISBNS: "reconciliation.find_isbns",
        HISTORY: "reconciliation.history"
    },
    HISTORY: {
        FILTERS: "history.filters",
        ORDER_TRACK: "order_track"
    },
    HELPERS: {
        TAGS: "helpers.tags",
        COVER : "helpers.cover",
        CUSTOMER_NAME: "helpers.customer_name",
        CUSTOMER_SELECT: "helpers.customer_select",
        CUSTOMER_TYPES: "helpers.customer_types",
        CUSTOMER_TYPES_EDIT: "helpers.customer_types_edit",
        CUSTOMER_TYPES_COUNT: "helpers.customer_types_count",
        CUSTOMER_PHONE: "helpers.customer_phone",
        INVOICE_SELECTOR: "helpers.invoice_selector",
        INVOICE_TITLE_SELECTOR: "helpers.invoice_title_selector",
        PREF_TYPES : "helpers.pref_types",
        CLASS_SELECTOR: "helpers.class_selector",
        USED_CONDITIONS: "helpers.used_conditions",
        BINDINGS: "helpers.bindings",
        CONDITIONS: "helpers.conditions",
        NOTE_INDICATORS: "helpers.note_indicators",
        BISACS: "helpers.bisacs",
        BISACS_RIGHT: "helpers.bisacs_right",
        OS_STATS: "helpers.out_of_order_status",
        TITLELINK_SEARCH: "helpers.titlelink_search",
        TITLELINK_SETTINGS : "helpers.titlelink_settings",
        PICKER: "helpers.picker",
        TITLELINK_DATA: "helpers.titlelink_data",
        CONFIRM: "helpers.confirm",
        HELP: "helpers.help",
        OPTIONS: "helpers.options",
        INFO: "helpers.info",
        WORKSTATION: "helpers.workstation",
        POPUP: "helpers.popup",
        PROMPT: "helpers.prompt"
    },
    MISC: {
        SELECTOR: "misc.selector",
        TEST : "misc.test",
        TEST_DETAILS : "misc.test_details"
    },
    MAIN: "main"

}